module.exports = __webpack_public_path__ + "static/media/foto2.6a7581a8.png";